export const LOGOUT = '@auth/LOGOUT'
